import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { Action } from 'redux';
import { AsyncAction } from 'redux-promise-middleware';

export const API_PATH_ACTIVE_ALARMS = '/alarms/active';
export const API_PATH_SUPPRESSED_ALARMS = '/alarms/suppressed';
export const API_PATH_UNSUPPRESSED_ALAMRS = '/alarms/unsuppressed';
export const API_PATH_HISTORICAL_ALARMS = '/alarms/historical';

export const FETCH_ACTIVE_ALARM = 'FETCH_ACTIVE_ALARM';
export const FETCH_ACTIVE_ALARM_PENDING = 'FETCH_ACTIVE_ALARM_PENDING';
export const FETCH_ACTIVE_ALARM_FULFILLED = 'FETCH_ACTIVE_ALARM_FULFILLED';
export const FETCH_ACTIVE_ALARM_REJECTED = 'FETCH_ACTIVE_ALARM_REJECTED';

export const FETCH_SUPPRESSED_ALARM = 'FETCH_SUPPRESSED_ALARM';
export const FETCH_SUPPRESSED_ALARM_PENDING = 'FETCH_SUPPRESSED_ALARM_PENDING';
export const FETCH_SUPPRESSED_ALARM_FULFILLED =
  'FETCH_SUPPRESSED_ALARM_FULFILLED';
export const FETCH_SUPPRESSED_ALARM_REJECTED =
  'FETCH_SUPPRESSED_ALARM_REJECTED';

export const FETCH_HISTORICAL_ALARM = 'FETCH_HISTORICAL_ALARM';
export const FETCH_HISTORICAL_ALARM_PENDING = 'FETCH_HISTORICAL_ALARM_PENDING';
export const FETCH_HISTORICAL_ALARM_FULFILLED =
  'FETCH_HISTORICAL_ALARM_FULFILLED';
export const FETCH_HISTORICAL_ALARM_REJECTED =
  'FETCH_HISTORICAL_ALARM_REJECTED';

export const SUPPRESS_ACTIVE_ALARM = 'SUPPRESS_ACTIVE_ALARM';
export const SUPPRESS_ACTIVE_ALARM_FULFILLED = 'SUPPRESS_ACTIVE_ALARM_FULFILLED';

export interface ActiveAlarm {
  alarmid: string;
  instance: string;
  level: string;
  module: number;
  number: number;
  ss8group: string;
  count: number;
  text: string;
  date: string;
  time: string;
  timestamp?: string;
}

export interface SuppressedAlarm {
  alarmid: string;
  module: number;
  number: number;
  instance: string;
  level: string;
  almGroupId: string;
  text: string;
  date: string;
  time: string;
}

export interface HistoricalAlarm {
  alarmid: string;
  level: string;
  source: string;
  message: string;
  datetime: string;
  src_host: string;
}

export interface FetchSuppressedAlarmsAction extends AsyncAction {
  type: typeof FETCH_SUPPRESSED_ALARM;
  payload: AxiosPromise<ServerResponse<SuppressedAlarm>>;
}

export interface FetchSuppressedAlarmsFulfilledAction extends Action {
  type: typeof FETCH_SUPPRESSED_ALARM_FULFILLED;
  payload: AxiosPromise<ServerResponse<SuppressedAlarm>>;
}

export interface FetchHistoricalAlarmsAction extends AsyncAction {
  type: typeof FETCH_HISTORICAL_ALARM;
  payload: AxiosPromise<ServerResponse<HistoricalAlarm>>;
}

export interface FetchHistoricalAlarmsFulfilledAction extends Action {
  type: typeof FETCH_HISTORICAL_ALARM_FULFILLED;
  payload: AxiosPromise<ServerResponse<HistoricalAlarm>>;
}

export interface SuppressActiveAlarmsAction extends AsyncAction {
  type: typeof SUPPRESS_ACTIVE_ALARM;
  payload: AxiosPromise<ServerResponse<void>>;
}

export interface SuppressActiveAlarmsFulfilledAction extends AsyncAction {
  type: typeof SUPPRESS_ACTIVE_ALARM_FULFILLED;
  payload: AxiosPromise<ServerResponse<void>>;
}

export interface AlarmState {
  activeAlarms: ActiveAlarm[];
  suppressedAlarms: [];
  historicalAlarms: [];
}

export type AlarmActionTypes =
  | FetchSuppressedAlarmsAction
  | FetchHistoricalAlarmsAction
  | FetchSuppressedAlarmsFulfilledAction
  | FetchHistoricalAlarmsFulfilledAction
  | SuppressActiveAlarmsAction
  | SuppressActiveAlarmsFulfilledAction;
